var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.task.id === "create"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: function () {
                  return _vm.createTask(true)
                },
                expression: "() => createTask(true)",
              },
            ],
            class: [_vm.$.card, _vm.$.create_mode],
          },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name",
                },
              ],
              ref: "nameInput",
              class: _vm.$.name_input,
              attrs: {
                placeholder: _vm.locale("board_task_enter_name"),
                rows: "1",
              },
              domProps: { value: _vm.name },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return (function () {
                    return _vm.createTask()
                  })($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { ref: "nameDisplay", class: [_vm.$.name, _vm.$.create_mode] },
              [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]
            ),
          ]
        )
      : _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  trigger: "manual",
                  theme: "board-card",
                  placement: "right-start",
                  content: _vm.tippyContent,
                  boundary: _vm.tippyBoundary,
                  popperOptions: {
                    modifiers: {
                      flip: {
                        boundariesElement: _vm.tippyBoundary,
                        flipVariationsByContent: true,
                      },
                    },
                  },
                },
                expression:
                  "{\n      trigger: 'manual',\n      theme: 'board-card',\n      placement: 'right-start',\n      content: tippyContent,\n      boundary: tippyBoundary,\n      popperOptions: {\n        modifiers: {\n          flip: {\n            boundariesElement: tippyBoundary,\n            flipVariationsByContent: true\n          },\n        },\n      }\n    }",
              },
            ],
            ref: "mainWrapper",
            class: [
              _vm.$.card,
              _vm.highlightOverdue && _vm.isTaskOvedue ? _vm.$.overdue : "",
              _vm.settingsOpened ? _vm.$.settings_opened : "",
              "card-wrapper",
            ],
            on: { click: _vm.cardClickHandler },
          },
          [
            _c("div", { class: _vm.$.header }, [
              _c(
                "div",
                {
                  class: _vm.$.path,
                  on: {
                    mouseover: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleCardTip(true)
                    },
                    mouseleave: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleCardTip(false)
                    },
                  },
                },
                _vm._l(_vm.breadcrumbs.shortened, function (breadcrumb) {
                  return _c("span", [
                    _vm._v("\n          " + _vm._s(breadcrumb) + "\n        "),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { class: [_vm.$.name_and_color] }, [
                _c(
                  "div",
                  {
                    class: [
                      _vm.$.color,
                      "inner_clickable",
                      _vm.paletteOpened ? _vm.$.palette_opened : "",
                      _vm.nameEditing ? _vm.$.disable_hover : "",
                    ],
                  },
                  [
                    _c("vgp-color-palette", {
                      ref: "colorPalette",
                      class: _vm.$.color_picker,
                      attrs: {
                        disabled: _vm.isFieldDisabled("color", _vm.task),
                        "select-type": "single",
                        "select-field": "square",
                        "selected-values": [_vm.task.color],
                        colors: _vm.colors.data,
                        "select-width": 72,
                        "select-height": 32,
                        "drop-position": "fixed",
                        small: "",
                      },
                      on: {
                        showPalette: _vm.colorPaletteHandler,
                        selectColors: function (e) {
                          return _vm.handleChangeData("color", e[0].id)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.nameEditing,
                      expression: "nameEditing",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name",
                    },
                  ],
                  ref: "nameInput",
                  class: [_vm.$.name_input, _vm.$.edit_mode],
                  attrs: { placeholder: _vm.locale("board_task_enter_name") },
                  domProps: { value: _vm.name },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                    blur: _vm.updateName,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.updateName($event)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "nameDisplay",
                    class: [_vm.$.name, _vm.nameEditing ? _vm.$.edit_mode : ""],
                    on: {
                      mouseover: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleCardTip(true)
                      },
                      mouseleave: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleCardTip(false)
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.$.primary_info }, [
              _c(
                "div",
                { class: _vm.$.left, on: { click: _vm.hideResourcePopup } },
                [
                  _vm.groupingFieldInfo.key !== "status"
                    ? _c(
                        "div",
                        {
                          class: [
                            _vm.$.status,
                            "inner_clickable",
                            _vm.isStatusEditing ? _vm.$.active : "",
                            _vm.isFieldDisabled("status", _vm.task)
                              ? _vm.$.disabled
                              : "",
                          ],
                          on: {
                            click: function (e) {
                              return _vm.handleClickStatusAndPriority(
                                e,
                                "status"
                              )
                            },
                          },
                        },
                        [
                          _c("svg-sprite", {
                            style: { color: _vm.taskStatus.color },
                            attrs: {
                              name: _vm.taskStatus.icon,
                              type: "bold",
                              size: 16,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { class: _vm.$.status__label }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.taskStatus.value) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.groupingFieldInfo.key !== "priority"
                    ? _c(
                        "div",
                        {
                          class: [
                            _vm.$.priority,
                            "inner_clickable",
                            _vm.isPriorityEditing ? _vm.$.active : "",
                            _vm.isFieldDisabled("priority", _vm.task)
                              ? _vm.$.disabled
                              : "",
                          ],
                          on: {
                            click: function (e) {
                              return _vm.handleClickStatusAndPriority(
                                e,
                                "priority"
                              )
                            },
                          },
                        },
                        [
                          _c("svg-sprite", {
                            style: { color: _vm.taskPriority.color },
                            attrs: {
                              name: _vm.taskPriority.icon,
                              type: "bold",
                              size: 16,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { class: _vm.$.priority__label }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.taskPriority.value) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$.right },
                [
                  _c("assigned-select", {
                    class: [
                      _vm.$.resources,
                      "inner_clickable",
                      _vm.isFieldDisabled("resources", _vm.task)
                        ? _vm.$.disabled
                        : "",
                    ],
                    attrs: {
                      resources: _vm.formattedResources,
                      "max-visible": 3,
                      "is-active": _vm.isAssignResourcesPopupShown,
                    },
                    on: { onClick: _vm.showAssignResourcesPopup },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.$.footer }, [
              _c(
                "div",
                {
                  ref: "dates",
                  class: _vm.$.dates,
                  style: {
                    maxWidth: _vm.datesWidth + "px",
                  },
                  on: { click: _vm.hideResourcePopup },
                },
                [
                  _c(
                    "div",
                    { class: [_vm.$.date_picker_wrapper, "inner_clickable"] },
                    [
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.startDateShow,
                            expression: "!startDateShow",
                          },
                        ],
                        class: [
                          _vm.$.date_blocker,
                          _vm.isFieldDisabled("start_date", _vm.task)
                            ? _vm.$.disabled
                            : "",
                        ],
                        on: {
                          click: function (e) {
                            return _vm.showDatePicker(e, "startDate")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("date-picker", {
                        ref: "startDatePicker",
                        class: _vm.$.date_picker,
                        attrs: {
                          value: _vm.task.start_date,
                          "task-data": _vm.task,
                          customClass: "board_card_date_picker",
                          property: "start_date",
                          "calendar-icon": false,
                        },
                        on: {
                          showCalendar: function (flag) {
                            return _vm.showCalendar("startDate", flag)
                          },
                          change: function (val) {
                            return _vm.handleChangeDate("start_date", val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { class: _vm.$.separator }, [
                    _vm._v("\n          -\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: [_vm.$.date_picker_wrapper, "inner_clickable"] },
                    [
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.endDateShow,
                            expression: "!endDateShow",
                          },
                        ],
                        class: [
                          _vm.$.date_blocker,
                          _vm.isFieldDisabled("end_date", _vm.task)
                            ? _vm.$.disabled
                            : "",
                        ],
                        on: {
                          click: function (e) {
                            return _vm.showDatePicker(e, "endDate")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("date-picker", {
                        ref: "endDatePicker",
                        class: [
                          _vm.$.date_picker,
                          _vm.highlightOverdue && _vm.isTaskOvedue
                            ? _vm.$.overdue
                            : "",
                        ],
                        attrs: {
                          value: _vm.task.end_date,
                          "task-data": _vm.task,
                          customClass: "board_card_date_picker",
                          property: "end_date",
                          "calendar-icon": false,
                        },
                        on: {
                          showCalendar: function (flag) {
                            return _vm.showCalendar("endDate", flag)
                          },
                          change: function (val) {
                            return _vm.handleChangeDate("end_date", val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.$.status_bar,
                  on: { click: _vm.hideResourcePopup },
                },
                [
                  _vm.task.hasComments
                    ? _c(
                        "div",
                        {
                          class: [
                            _vm.$.comments,
                            "inner_clickable",
                            _vm.task.newComments ? _vm.$.new : "",
                          ],
                          on: {
                            click: function () {
                              return _vm.taskSettingsHandler("comments")
                            },
                          },
                        },
                        [
                          _c("svg-sprite", {
                            attrs: { name: "comments", size: 20 },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task.hasAttachments
                    ? _c(
                        "div",
                        {
                          class: [_vm.$.attachments, "inner_clickable"],
                          on: {
                            click: function () {
                              return _vm.taskSettingsHandler("attachments")
                            },
                          },
                        },
                        [
                          _c("svg-sprite", {
                            attrs: { name: "attach", size: 20 },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            !(_vm.nameEditing || _vm.taskSettingsInfo)
              ? _c(
                  "div",
                  {
                    class: [_vm.$.context_menu, "inner_clickable"],
                    on: { click: _vm.hideResourcePopup },
                  },
                  [
                    _c("iconButton", {
                      attrs: {
                        icon: { name: "more-1", type: "regular", size: 20 },
                        colors: {
                          color: "#808080",
                          bg: "#E5E5E5",
                          hoverBg: "#CCCCCC",
                          activeBg: "#B2B2B2",
                          activeColor: "#808080",
                        },
                      },
                      on: {
                        onClick: function (e) {
                          return _vm.toggleContextMenu(
                            Object.assign({}, _vm.task, {
                              columnId: _vm.columnId,
                            }),
                            "task",
                            "main",
                            e.target
                          )
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.taskSettingsInfo || _vm.task.id === "draft"
              ? _c("div", {
                  class: [
                    _vm.$.mouse_events_blocker,
                    _vm.task.id === "draft" ? _vm.$.mouse_loader : "",
                  ],
                  on: { click: _vm.taskSettingsHandler },
                })
              : _vm._e(),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }